import { Modal, ModalBody, ModalHeader, CardBody, CardTitle } from 'reactstrap'
import { IconTrash } from '@tabler/icons-react'
import { IconX } from '@tabler/icons-react'
//@ts-ignore
import { Button } from 'dsm-react-lib'

interface RemoveProjectFileModalProps {
  isOpen: boolean
  toggle: () => void
  onRemove: () => void
  fileName: string
  isRemoving: boolean
}

const RemoveProjectFileModal: React.FC<RemoveProjectFileModalProps> = ({
  isOpen,
  toggle,
  onRemove,
  fileName,
  isRemoving
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered data-testid="remove-project-file-modal">
      <ModalHeader
        className={`!justify-between !border-0 !flex !items-center chat-primary theme-bg`}
        toggle={toggle}
        close={
          <IconX
            size={24}
            onClick={toggle}
            className="theme-text-subheading transition-colors duration-300 ease-in-out hover:text-white cursor-pointer"
            data-testid="close-button"
          />
        }>
        <div className="flex items-center">
          <IconTrash className="me-1" color="white" />
          <span className="text-white">Remove file?</span>
        </div>
      </ModalHeader>
      <ModalBody className="flex-grow-1">
        <div className="text-center border-0">
          <CardBody className="px-0 py-1">
            <CardTitle tag="h4">
              Are you sure you want to remove <b>{fileName}</b> from this project?
            </CardTitle>
          </CardBody>
        </div>
        <div className={`flex justify-end gap-1 my-1 chat-primary`}>
          <Button
            label="Cancel"
            variant="outline"
            color="neutral"
            className="dsm-btn-neutral"
            onClick={toggle}
            data-testid="cancel-remove-file-button"
          />
          <Button
            label={isRemoving ? 'Removing...' : 'Confirm'}
            color="danger"
            disabled={isRemoving}
            onClick={onRemove}
            data-testid="confirm-remove-file-button"
          />
        </div>
      </ModalBody>
    </Modal>
  )
}

export default RemoveProjectFileModal
